import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import {
  Col,
  FormGroup,
  Row,
  Card,
  CardTitle,
  CardBody,
  CardText,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import PropTypes from "prop-types";
import CustomSelect from "../Common/CustomSelect";
import { AvField, AvForm } from "availity-reactstrap-validation";

//Import Scrollbar
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

const VerticalLayoutDashboard = props => {
  const [chartsItem, setChartsItem] = React.useState([]);

  const sort_types = [{ label: "Sort by name", value: "by_name" }];

  React.useEffect(() => {
    if (props.status) {
      //console.log("IN");
      setChartsItem([
        {
          title: "Bar chart",
          description:
            "Some quick example text to build on the card title and make up the bulk of the content.",
        },
        {
          title: "Line chart",
          description:
            "Some quick example text to build on the card title and make up the bulk of the content.",
        },
        {
          title: "Pie chart",
          description:
            "Some quick example text to build on the card title and make up the bulk of the content.",
        },
        {
          title: "Bar chart",
          description:
            "Some quick example text to build on the card title and make up the bulk of the content.",
        },
        {
          title: "Line chart",
          description:
            "Some quick example text to build on the card title and make up the bulk of the content.",
        },
        {
          title: "Pie chart",
          description:
            "Some quick example text to build on the card title and make up the bulk of the content.",
        },
        {
          title: "Bar chart",
          description:
            "Some quick example text to build on the card title and make up the bulk of the content.",
        },
        {
          title: "Line chart",
          description:
            "Some quick example text to build on the card title and make up the bulk of the content.",
        },
        {
          title: "Pie chart",
          description:
            "Some quick example text to build on the card title and make up the bulk of the content.",
        },
      ]);
    } else if (!props.status) {
      //console.log("out");
    }
  }, [props.status]);

  return (
    <React.Fragment>
      <SimpleBar style={{ height: "100%", overflow: "hidden" }}>
        <div data-simplebar className="h-100">
          <div className="rightbar-title px-3 py-4">
            <Link
              to="#"
              className="right-bar-toggle float-end"
              onClick={() => props.onClose()}
            >
              <i className="mdi mdi-close noti-icon" />
            </Link>
            <h5 className="m-0">Charts</h5>
          </div>

          <hr className="my-0" />

          <div className="px-3 py-4">
            <AvForm>
              <Row>
                <Col sm={6}>
                  <FormGroup className="mb-3">
                    <AvField
                      className="p-2"
                      name={"search_chart"}
                      placeholder="Filtered your charts..."
                      type="text"
                    />
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup className="mb-3">
                    <StyledSelect
                      name="sort_charts"
                      options={sort_types}
                      placeholder={`Sort type`}
                      classNamePrefix="select2-selection"
                      // isLoading={this.props.isLoading}
                      defaultValue={sort_types[0]}
                      // defaultValue={getDefaultValueForSelect(
                      //   this.props.offer?.app
                      // )}
                      // onChange={this.handleChangeApplications}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <hr className="mt-1" />
            </AvForm>

            <Row>
              <PerfectScrollbar
                style={{
                  height: "100%",
                  minHeight: "150px",
                  maxHeight: "900px",
                }}
              >
                {chartsItem.length > 0 &&
                  chartsItem.map((item, key) => (
                    <Col xl={12} key={key}>
                      <StyledCard outline className="border user-select-none">
                        <CardBody>
                          <CardTitle className="h5 mt-0">
                            {item.title}
                          </CardTitle>
                          <CardText>{item.description}</CardText>
                        </CardBody>
                      </StyledCard>
                    </Col>
                  ))}
              </PerfectScrollbar>
            </Row>
          </div>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

const StyledSelect = styled(CustomSelect)`
  .css-1pahdxg-control {
    box-shadow: none !important;
  }
`;

const StyledCard = styled(Card)`
  cursor: pointer;
  box-shadow: 5rem 0.75rem 1.5rem rgb(18 38 63 / 3%);
  transition-duration: 500ms;

  &:hover {
    transition-duration: 500ms;
    background: rgba(0, 0, 0, 0.05);
  }
`;

VerticalLayoutDashboard.propTypes = {
  status: PropTypes.bool,
  onClose: PropTypes.func,
};

export default VerticalLayoutDashboard;
